export const checkIsArrayEmpty = (arr: Array<unknown> | null | undefined) =>
  (arr || []).length === 0;
